<section class="flex flex-col sm:min-h-[25.6rem] min-h-[40rem] sm:max-h-[60vh] px-[2rem] py-[1rem] overflow-hidden sm:min-w-[40rem]  sm:max-w-[35vw] max-sm:min-w-[60vw] bg-white" role="dialog" aria-modal="true" aria-labelledby="message-title">
    <mat-dialog-content class="!flex !flex-1 items-center justify-center text-center" role="document">
        <p id="message-title" class="dsr-typescale-body-medium">{{data.message}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="">
        <button mat-flat-button class="" (click)="closeDialog()" type="button" aria-label="Close message">
            <span class="">OK</span>
        </button>
    </mat-dialog-actions>
</section>